/**
 * Environment Configuration
 * Centralized configuration for environment variables
 */

export const ENV = {
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',

  // Firebase Configuration
  FIREBASE: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDtoQnEsefVM6waYKECqDQeUV07rRikobc',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'petfostering-7917d.firebaseapp.com',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'petfostering-7917d',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'petfostering-7917d.firebasestorage.app',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '131299956581',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:131299956581:web:58d2f62396ff6d7a4d738c',
  },

  // API Configuration
  API: {
    BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3007',
    TIMEOUT: 30000,
  },

  // Feature Flags
  FEATURES: {
    ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS !== 'false',
    ENABLE_ERROR_TRACKING: process.env.REACT_APP_ENABLE_ERROR_TRACKING !== 'false',
    ENABLE_CHATBOT: process.env.REACT_APP_ENABLE_CHATBOT === 'true',
    ENABLE_SUBSCRIPTIONS: true,
    ENABLE_OFFLINE_JOBS: true,
  },

  // File Upload Limits
  UPLOAD: {
    MAX_FILE_SIZE: parseInt(process.env.REACT_APP_MAX_FILE_SIZE) || 5242880, // 5MB
    MAX_IMAGE_SIZE: parseInt(process.env.REACT_APP_MAX_IMAGE_SIZE) || 5242880,
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
    PROFILE_IMAGE_DIMENSIONS: { width: 400, height: 400 },
    COVER_IMAGE_DIMENSIONS: { width: 1200, height: 300 },
  },

  // App / Brand Configuration
  APP: {
    NAME: 'PetsFostering',
    LEGAL_NAME: 'PetsFostering',
    TAGLINE: 'Premium Pet Care Marketplace',
    DOMAIN: 'petsfostering.com',
    URL: process.env.REACT_APP_HOSTING_URL || 'https://petsfostering.com',
    HOSTING_URL: process.env.REACT_APP_HOSTING_URL || 'https://petsfostering.com',
    SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'support@petsfostering.com',
    VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',
    BUILD_ID: process.env.REACT_APP_BUILD_ID || 'local',
    DEFAULT_PORT: 6565,
  },

  /** Canonical subscription pricing shown across paywalls */
  SUBSCRIPTION: {
    OFFLINE_JOBS_MONTHLY: 79,
  },
};

// Validation: Ensure critical env vars are set in production
if (ENV.IS_PRODUCTION) {
  const requiredVars = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_PROJECT_ID',
  ];

  requiredVars.forEach((varName) => {
    if (!process.env[varName]) {
      console.error(`❌ Missing required environment variable: ${varName}`);
    }
  });
}

export default ENV;

